import React from "react";
import { AddPlanContextProvider } from "./AddPlanView";
import AddPlan from "./views/AddPlan";

const AddSubsrciptionPlanPage = () => {
  return (
    <div>
      <AddPlanContextProvider>
        <AddPlan />
      </AddPlanContextProvider>
    </div>
  );
};

export default AddSubsrciptionPlanPage;
